import { useMutation } from '@tanstack/react-query';
import { EmailApi } from './api';
import type { DemoRequestDto } from './types';

export const useSubmitDemoRequest = () => {
  return useMutation({
    mutationFn: (data: DemoRequestDto) => EmailApi.submitDemoRequest(data),
  });
};
